var InteractiveParameter = require('./InteractiveParameter');

/**
 * Параметры конструктора InteractiveParametersGroup
 * @typedef {Object} InteractiveParametersGroupConstructorParams
 * @property {Object.<string, InteractiveParameterConstructorParams>} InteractiveParametersConstructorParams - Параметры для создания объектов интерактивных параметров
 * @property {string} [selector] - Селектор группы, задающий контекст, в котором рассматриваются интерактивные параметры (прибавляющийся к селекторам интерактивных параметров)
 */

/**
 * Группа интерактивных параметров
 * @param {InteractiveParametersGroupConstructorParams} params
 * @constructor
 */
function InteractiveParametersGroup(params) {
    /**
     * Интерактивные параметры группы по именам
     * @type {Object.<string, InteractiveParameter>}
     */
    this.InteractiveParameters = {};
    /**
     * Селектор группы
     * @type {string|null}
     */
    this.selector = params.selector || null;
    // Создание и запись в группу объектов InteractiveParameter
    for (var parameterName in params.InteractiveParametersConstructorParams) {
        this.InteractiveParameters[parameterName] =
            new InteractiveParameter({
                selector: this.selector
                              ? this.selector + ' ' + params.InteractiveParametersConstructorParams[parameterName].selector
                                  : params.InteractiveParametersConstructorParams[parameterName].selector,
                indexBy: params.InteractiveParametersConstructorParams[parameterName].indexBy,
                classActive: params.InteractiveParametersConstructorParams[parameterName].classActive,
                classHidden: params.InteractiveParametersConstructorParams[parameterName].classHidden,
                disabledCursor: params.InteractiveParametersConstructorParams[parameterName].disabledCursor,
                init: params.InteractiveParametersConstructorParams[parameterName].init,
                onClick: params.InteractiveParametersConstructorParams[parameterName].onClick,
                InteractiveParametersGroup: this
            });
    }
}

InteractiveParametersGroup.prototype = {
    /**
     * Метод определяет по имени, определен ли параметр в группе и имеет ли элементы
     * @param {string} name
     * @returns {boolean}
     */
    isParameterDefinedAndHasElements: function (name) {
        return this.InteractiveParameters[name] && this.InteractiveParameters[name].elementsCount;
    },
    /**
     * Метод инициализирует параметры в группе
     * Является оберткой для InteractiveParameter.init() параметров группы
     * @param {Array|"*"|false} [applyToRelated] - Массив имен параметров,
     *                                             для которых пометить связанные параметры инициализированными,
     *                                             или строка '*', чтобы применить это действие ко всем параметрам,
     *                                             или false, чтобы инициализацию связанных параметров не рассматривать (по умолчанию)
     */
    initInteractiveParameters: function (applyToRelated) {
        if (!applyToRelated) {
            for (var name in this.InteractiveParameters) {
                if (!this.InteractiveParameters[name].initialized) {
                    this.InteractiveParameters[name].init();
                }
            }
        } else if (applyToRelated instanceof Array) {
            for (var name in this.InteractiveParameters) {
                if (!this.InteractiveParameters[name].initialized) {
                    this.InteractiveParameters[name].init(applyToRelated.indexOf(name) !== -1);
                }
            }
        } else if (applyToRelated === '*') {
            for (var name in this.InteractiveParameters) {
                if (!this.InteractiveParameters[name].initialized) {
                    this.InteractiveParameters[name].init(true);
                }
            }
        }
    },
    /**
     * Метод связывает данную группу параметров с переданной по именам параметров в группах
     * @param {InteractiveParametersGroup} InteractiveParametersGroup
     */
    relateWith: function (InteractiveParametersGroup) {
        if (InteractiveParametersGroup !== this){
            for (var parameterName in this.InteractiveParameters) {
                if (InteractiveParametersGroup.InteractiveParameters[parameterName]) {
                    this.InteractiveParameters[parameterName].relateWith(InteractiveParametersGroup.InteractiveParameters[parameterName]);
                }
            }
        }
    }
};

module.exports = InteractiveParametersGroup;



// WEBPACK FOOTER //
// ./assets/javascript/interactive_parameters/module/InteractiveParametersGroup.js